/** English admin strings. These keys are the source of truth: fr.ts and es.ts must have every key (type-checked).
 * English is bundled with the app; French and Spanish load on demand (see `loadStrings` in i18n.ts). */
const en = {
  comments: "Comments",
  commentsIntro: "Comments on {account}'s posts from the last 90 days. Answer shopping questions with a link to the product tagged on the post.",
  commentsIntroNoAccount: "Connect Instagram to see comments on your posts and answer shopping questions with product links.",
  commentsLockedTitle: "Turn comments into orders",
  commentsLocked: "See shoppers' questions on your posts in one place and reply with a link to the tagged product in one click.",
  reconnectForComments: "Reconnect Instagram to manage comments. Instagram asks for one more permission: managing comments on your posts.",
  tabQuestions: "Questions",
  tabAllComments: "All",
  tabHiddenComments: "Hidden",
  noQuestions: "No questions waiting. New ones show up here within a minute.",
  noComments: "No comments on your posts from the last 90 days yet.",
  noHiddenComments: "No hidden comments.",
  commentQuestion: "Question",
  commentSpam: "Looks like spam",
  commentOther: "Comment",
  commentReplied: "Replied",
  commentHidden: "Hidden",
  commentShopper: "A shopper",
  commentYou: "You",
  commentReplies: "Replies",
  selectComment: "Select comment from {who}",
  viewOnInstagram: "View post on Instagram",
  savedReply: "Saved reply",
  savedReplyPick: "Use a saved reply",
  replyTo: "Reply to {who}",
  sendReply: "Send reply",
  replySent: "Reply posted on Instagram",
  hideComment: "Hide",
  unhideComment: "Unhide",
  commentHiddenToast: "Comment hidden on Instagram",
  commentShownToast: "Comment visible again on Instagram",
  dismissComment: "Not a question",
  undismissComment: "Back to questions",
  commentUpdated: "Updated",
  deleteComment: "Delete",
  deleteCommentTitle: "Delete this comment?",
  deleteCommentText: "It is deleted on Instagram too, with its replies. This can't be undone.",
  commentDeleted: "Comment deleted on Instagram",
  hideSelected: "Hide {n} selected",
  commentsHidden: "Hid {n} comments on Instagram",
  fComments: "Comments inbox with product-link replies",
  emailOnCustomerPosts: "Email me when customer posts are waiting",
  emailOnCustomerPostsHelp: "At most once a day, only while approval is on.",
  customerPosts: "Customer posts",
  customerPostsIntro: "Posts where shoppers tagged {account} on Instagram. Approve the ones you want on your store; each one credits its creator.",
  customerPostsIntroNoAccount: "Posts where shoppers tagged your Instagram account. Approve the ones you want on your store; each one credits its creator.",
  tabPending: "Waiting",
  tabApproved: "Approved",
  tabRejected: "Rejected",
  approve: "Approve",
  reject: "Reject",
  moveToPending: "Move back to waiting",
  approveSelected: "Approve {n}",
  rejectSelected: "Reject {n}",
  selectPost: "Select post by @{author}",
  postsApproved: "{n} approved — live on your store in a few seconds",
  postsRejected: "{n} rejected",
  postsMoved: "Moved back to waiting",
  requireApproval: "Approve each post before it shows on my store",
  requireApprovalHelp: "Turn off to show new customer posts automatically.",
  noCustomerPosts: "Nothing here yet. When a shopper tags your Instagram account in a public post, it appears here within an hour.",
  reconnectForCustomerPosts: "Reconnect Instagram to collect customer posts. Instagram asks for one more permission: reading posts you're tagged in.",
  customerPostsLockedTitle: "Show posts from your customers",
  customerPostsLocked: "Collect posts where shoppers tag your store, approve the best ones and show them with credit to their creators.",
  byCreator: "by @{author}",
  dashboard: "Dashboard",
  feeds: "Feeds",
  files: "Files",
  plans: "Plans",
  settings: "Settings",
  help: "Help",
  about: "About",
  whatsNew: "What's new",
  loading: "Loading…",
  error: "Something went wrong. Please reload.",
  welcome: "Welcome to UnboxUGC",
  plan: "Plan",
  comingSoon: "Coming soon in this beta.",
  version: "Version",
  contactSupport: "Contact support",
  testStore: "Development store",
  instagram: "Instagram",
  connectInstagram: "Connect Instagram",
  connectPrompt: "Connect your Instagram professional account to show your posts and Reels on your store.",
  connectedBanner: "Instagram connected. Your posts will appear shortly.",
  connectError: "Instagram wasn't connected. Please try again.",
  disconnect: "Disconnect",
  disconnected: "Instagram disconnected",
  reconnect: "Reconnect",
  posts: "posts",
  followers: "followers",
  lastSynced: "synced",
  processing: "Please hang on while we process your posts…",
  ready: "ready",
  failed: "failed",
  refresh: "Refresh",
  refreshQueued: "Fetching new posts…",
  refreshTooSoon: "Just refreshed. Try again in a couple of minutes.",
  needsReconnect: "Instagram needs to be reconnected.",
  tagProducts: "Tag products",
  tagProductsIntro: "Shoppers see these products in the post's popup.",
  addProducts: "Add products",
  addCollection: "Add collection",
  taggedProducts: "Tagged products",
  noTags: "No products tagged yet.",
  showDot: "Show a dot on the picture",
  removeTag: "Remove",
  photos: "Photos",
  photoN: "Photo {n}",
  dotLabel: "{name}, at {x}% across and {y}% down. Use the arrow keys to move it.",
  dragHint: "Drag a dot onto its product, or select a product and click the picture. Arrow keys move the selected dot.",
  tagsSaved: "Tags saved",
  tagsFailed: "Couldn't save the tags. Check the products still exist and try again.",
  tagLimit: "Your plan tags products on up to 6 posts. Upgrade to Pro to tag every post.",
  postNotFound: "This post isn't in your feed anymore.",
  taggedCount: "{n} tagged",
  tagsOffStore: "Tags saved, not on your store: your plan shows tags on {n} posts",
  bannerNoAccount: "Instagram is disconnected, so your feed isn't showing on your store.",
  howToUpdateTheme: "How to update your theme",
  bannerOldTheme: "Your theme is an older type that can't show apps like this one.",
  bannerNotLive: "Your feed isn't on your store yet.",
  bannerEmbedOff: "Your floating post isn't on your store yet. Turn on Floating feed in Theme settings > App embeds, then click Save.",
  turnOnEmbed: "Turn on in theme editor",
  checkAgain: "Check again",
  notFoundInterim: "We couldn't check your theme right now. Did you press Save in the theme editor?",
  titleLabel: "Title",
  optionalSuffix: "(optional)",
  autoplayText: "Play videos automatically (muted)",
  upgrade: "Upgrade",
  bannerDowngraded: "Floating layout needs Pro, so your feed now shows as a grid.",
  bannerDisconnected: "Instagram needs reconnecting. Your store still shows your last posts.",
  showPreview: "Show preview",
  goToPosts: "Go to Posts",
  stepCurateText: "Put your best posts first",
  stepCurate: "Hide or pin a post",
  chooseLayout: "Choose layout",
  stepLayoutHint: "Grid, slider, Reels row or floating",
  liveOnHomepage: "Live on homepage",
  stepConnectDone: "@{user} · {n} posts",
  guideCompleted: "{done} of {total} completed",
  fHidePin: "Hide, pin and reorder posts",
  startTrialDays: "Start 7-day free trial",
  description: "Description",
  versionLine: "Version {v}",
  connectedUpdated: "Connected · Updated {time}",
  updatedAgoShort: "Updated {time}",
  noPostsText: "Post something on Instagram, then press Refresh.",
  noPostsTitle: "No posts yet",
  whatsNewLink: "What's new",
  needHelp: "Need help?",
  instagramConnected: "Instagram connected",
  postsIntroPhone: "The order your posts show on your store. Use ••• to move a post.",
  productTags: "Product tags",
  home: "Home",
  postsTitle: "Posts",
  postsIntro: "The order your posts show on your store. Drag to reorder.",
  filterAll: "All ({n})",
  filterShowing: "Showing ({n})",
  filterHidden: "Hidden ({n})",
  refreshFromInstagram: "Refresh from Instagram",
  pinned: "Pinned",
  hidden: "Hidden",
  moveToStart: "Move to start",
  moveToEnd: "Move to end",
  openOnInstagram: "Open on Instagram",
  searchPosts: "Search captions",
  searchCustomerPosts: "Search by creator or caption",
  productsFilter: "Products",
  productsAny: "All posts",
  productsWith: "With products",
  productsWithout: "Without products",
  noMatches: "No posts match your search or filters.",
  clearFilters: "Clear filters",
  backToFeed: "Back to {feed}",
  moreActions: "More actions",
  imageDescription: "Image description",
  descHelp: "Helps people using screen readers and helps your store appear in Google Images.",
  resetAutomatic: "Reset to automatic",
  descSaved: "Image description saved",
  postShown: "Post shown",
  postPinned: "Post pinned",
  postUnpinned: "Post unpinned",
  postMoved: "Post moved",
  instagramAccount: "Instagram account",
  connected: "Connected",
  changeAccount: "Change account",
  changeAccountTitle: "Change Instagram account?",
  changeAccountText: "Instagram will ask you to log in, so you can choose the account to show on your store. Posts from {account}, with their pins and product tags, will be removed from UnboxUGC.",
  disconnectTitle: "Disconnect Instagram?",
  disconnectText: "Your feed will stop updating and stop showing on your store, and setup starts again from Connect Instagram. Reconnect the same account anytime to get your pins and order back.",
  emails: "Emails",
  emailOnDisconnect: "Email me if Instagram disconnects",
  sentTo: "Sent to {email}",
  emailOn: "Email turned on",
  emailOff: "Email turned off",
  privacyPolicy: "Privacy policy",
  currentPlan: "Current plan",
  payYearly: "Pay yearly (Plus saves 25%)",
  monthlyOnly: "monthly only",
  free: "Free",
  freeForever: "Free forever",
  perMonth: "/month",
  perYear: "/year",
  daysFree: "7 days free",
  starterTagline: "Show your Instagram on your store",
  proTagline: "Turn feed views into orders",
  plusTagline: "Automate and measure",
  everythingIn: "Everything in {plan}, plus:",
  foundingOffer: "Founding offer: the first 100 stores keep this price for life.",
  comparePlans: "Compare plans",
  fUnlimited: "Unlimited views, posts and Reels",
  fLayouts: "Grid and slider",
  fCuration: "Hide, pin and reorder posts",
  fTags6: "Product tags on 6 posts",
  fNoWatermark: "No watermark",
  fFloating: "Floating layout",
  fAutoplay: "Video autoplay",
  fTagsAll: "Product tags on every post",
  fMultiFeeds: "Multiple feeds",
  fUploads: "Upload your own photos and videos",
  fAnalytics: "Analytics",
  fPageFeeds: "Feeds that change per product page",
  tagsOn: "{n} posts",
  everyPost: "Every post",
  latestUpdates: "Latest updates",
  notifications: "Notifications",
  noNotifications: "You're all caught up.",
  notificationsUnread: "Notifications, {n} unread",
  openNotification: "Open",
  youreOn: "You're on v{v}",
  documentation: "Documentation",
  seeAllChanges: "See all changes",
  tagNew: "New",
  tagImprovement: "Improvement",
  tagFix: "Fix",
  latestBadge: "Latest",
  undo: "Undo",
  postHidden: "Post hidden",
  setupTitle: "Get your Instagram on your store",
  setupIntro: "Two required steps, about 2 minutes. Each step unlocks the next.",
  setupProgress: "{done} of {total} completed",
  required: "Required",
  optional: "Optional",
  stepConnect: "Connect Instagram",
  stepConnectText: "Show your latest posts and Reels on your store.",
  stepConnectNote: "Instagram opens in this window and brings you back here.",
  stepStore: "Add UnboxUGC to your store",
  stepStoreText: "Choose where your feed shows. We'll open your theme editor with the feed already added — just press Save.",
  stepStoreLocked: "Unlocks after you connect Instagram.",
  addToHomepage: "Add to homepage",
  also: "Also:",
  homepage: "Homepage",
  productPages: "Product pages",
  collectionPages: "Collection pages",
  otherPages: "Other pages",
  postsReadyCount: "{n} posts and Reels ready",
  gettingReady: "Getting your posts ready… {ready} of {total}",
  headsUpTitle: "One last step in your theme",
  headsUpText: "Your theme editor will open in a new tab with the feed already placed. Press Save in the top right, then come back here.",
  dontShowAgain: "Don't show this again",
  openThemeEditor: "Open theme editor",
  cancel: "Cancel",
  notFoundYet: "We couldn't find the feed on your store yet. Did you press Save in the theme editor?",
  openAgain: "Open theme editor again",
  pressedSave: "I pressed Save",
  liveOnStore: "Your feed is live on your homepage",
  stepLayout: "Choose a layout",
  stepLayoutText: "Your feed is live as a grid. Pick another layout now, or change it anytime on Home.",
  stepLayoutLocked: "Unlocks once your feed is on your store.",
  finishSetup: "Finish setup",
  skipForNow: "Skip for now",
  setupComplete: "Setup complete. Your feed is live.",
  needHand: "Need a hand?",
  needHandText: "Our team can set up your first feed with you.",
  yourFeed: "Your Instagram feed",
  setupGuide: "Setup guide",
  hideGuide: "Hide guide",
  status: "Status",
  showsOn: "Shows on:",
  updatedAgo: "Updated {time}",
  postsCount: "{n} posts",
  postsCountOne: "{n} post",
  layout: "Layout",
  layoutGrid: "Grid",
  layoutGridText: "Posts in rows",
  layoutSlider: "Slider",
  layoutSliderText: "One row you can scroll",
  layoutReels: "Reels row",
  layoutReelsText: "Tall posts in a scrolling row",
  layoutFloating: "Floating",
  layoutFloatingText: "A small post in the corner of every page",
  look: "Look",
  shape: "Shape",
  shapeSquare: "Square",
  shapePortrait: "Portrait",
  shapeTall: "Tall",
  shapeCircle: "Circle",
  corners: "Corners",
  gaps: "Gaps",
  sizeNone: "None",
  sizeSmall: "Small",
  sizeMedium: "Medium",
  sizeLarge: "Large",
  postsPerRow: "Posts per row",
  auto: "Auto",
  rows: "Rows",
  numberOfPosts: "Number of posts",
  feedTitle: "Title (optional)",
  titlePlaceholder: "e.g. Shop our Instagram",
  onClick: "When someone clicks a post",
  clickPopup: "Show it in a popup",
  popupStyle: "Popup style",
  popupDetailed: "Detailed",
  popupSimple: "Simple",
  popupLink: "Add a link to the post on Instagram",
  clickInstagram: "Open it on Instagram",
  clickNothing: "Do nothing",
  videos: "Videos",
  autoplay: "Play videos automatically (muted)",
  moreOptions: "More options",
  customizePhones: "Customize for phones",
  customizePhonesText: "Choose a different number of posts for phones.",
  postsPerRowPhones: "Posts per row on phones",
  rowsPhones: "Rows on phones",
  show: "Show",
  showAll: "Posts and Reels",
  showPosts: "Posts only",
  showReels: "Reels only",
  peek: "Show part of the next post at the edges of sliders",
  splitCarousel: "Show each photo of a carousel as its own post",
  preview: "Preview",
  phone: "Phone",
  computer: "Computer",
  previewHint: "Click a post to hide or pin it.",
  emptyPreview: "Your posts will appear here",
  hideFromStore: "Hide from store",
  showOnStore: "Show on store",
  pinToStart: "Pin to start",
  unpin: "Unpin",
  editDescription: "Edit image description",
  saved: "Saved — live on your store in a few seconds",
  saveFailed: "Couldn't save. Check your connection and try again.",
  save: "Save",
  discard: "Discard",
  pro: "PRO",
  upgradeTitle: "{feature} is part of Pro",
  upgradeFloating: "Show a small post in the corner of every page, so shoppers see your Instagram wherever they are.",
  upgradeAutoplay: "Videos start playing, muted, as shoppers scroll past them.",
  startTrial: "Start free trial",
  notNow: "Not now",
  upgradeToPlan: "Upgrade to {plan}",
  whatsIncluded: "What's included:",
  trialCancel: "{days}-day free trial • cancel anytime",
  startTrialN: "Start {days}-day trial",
  planChipLabel: "{plan} feature. See what's included",
  previous: "Previous",
  next: "Next",
  close: "Close",
  noPostsYet: "No posts yet. Post something on Instagram, then press Refresh.",
  autoplayAll: "All videos in view",
  autoplayOne: "One video at a time",
  autoplayHover: "When a shopper points at a video",
  autoplayOff: "Off",
  autoplayModesText: "Videos play muted. One at a time is lighter on phones.",
  sliderAdvance: "Move automatically",
  sliderAdvanceText: "Shows the next posts every 5 seconds and stops when a shopper interacts.",
  phoneLayout: "Phone layout",
  upgradeMobile: "Choose rows and posts per row for phones separately from computers.",
  filesIntro: "Upload your own photos and videos. They join your feeds like Instagram posts, and you can tag products on them.",
  dropFiles: "Drop photos or videos here",
  chooseFiles: "Choose files",
  fileLimits: "JPG, PNG or WebP up to 20 MB · MP4 or MOV up to 200 MB",
  fromLink: "Add from a link",
  linkLabel: "Link to a photo or video",
  addLink: "Add",
  linkQueued: "Downloading the file…",
  uploading: "Uploading",
  statusPending: "Waiting",
  statusProcessing: "Processing",
  statusReady: "Ready",
  statusFailed: "Failed",
  fileType: "Use a JPG, PNG or WebP photo, or an MP4 or MOV video.",
  fileTooLarge: "This file is too large.",
  uploadFailed: "Couldn't upload {name}.",
  fileDeleted: "File deleted",
  deleteFile: "Delete file",
  noFiles: "No files yet. Uploaded files also appear on the Posts page.",
  filesLockedTitle: "Upload your own photos and videos",
  filesLocked: "Add photos and videos from your computer or a link, and tag products on them.",
  plusBadge: "PLUS",
  upgradeTitlePlus: "{feature} is part of Plus",
  pageFilter: "Product and collection pages",
  pageFilterText: "Show the posts tagged with the product or collection a shopper is viewing.",
  pageFilterOff: "All posts",
  pageFilterMatching: "Only posts tagged with that product or collection",
  pageFilterFallback: "Tagged posts, or all posts when none are tagged",
  upgradePageFilter: "Each product and collection page shows the posts tagged with what the shopper is looking at.",
  analytics: "Analytics",
  analyticsIntro: "How shoppers use your feed. Updated every hour.",
  last7: "Last 7 days",
  last30: "Last 30 days",
  last90: "Last 90 days",
  metricViews: "Feed views",
  metricOpens: "Post opens",
  metricClicks: "Product clicks",
  metricAddToCarts: "Add to carts",
  openRate: "Open rate",
  clickRate: "Click rate",
  openRateHelp: "Post opens ÷ feed views",
  clickRateHelp: "Product clicks ÷ post opens",
  vsPrevious: "{change}% vs previous {days} days",
  dailyChart: "Per day",
  topPosts: "Top posts",
  topProducts: "Top products",
  colPost: "Post",
  colProduct: "Product",
  colOpens: "Opens",
  colClicks: "Clicks",
  colAddToCarts: "Add to carts",
  noData: "No activity in this period yet. Data appears once shoppers see your feed.",
  noProducts: "No product clicks yet. Tag products on your posts to see them here.",
  analyticsLockedTitle: "See what your feed sells",
  analyticsLocked: "Views, post opens, product clicks and add to carts per post and product, over 7, 30 or 90 days.",
  homeStats: "Last 7 days",
  viewAnalytics: "View analytics",
  feed: "Feed",
  feedsIntro: "Show different posts or designs in different places, for example a Reels row on the homepage and a grid on product pages.",
  createFeed: "Create feed",
  feedName: "Feed name",
  feedNameHelp: "Only you see this name.",
  feedNamePlaceholder: "Summer collection",
  mainFeed: "Main",
  offStore: "Not on store",
  offStoreHelp: "Your plan includes one feed, so only the main feed shows on your store.",
  feedId: "Feed ID",
  copy: "Copy",
  copied: "Feed ID copied",
  colPosts: "Posts",
  edit: "Edit",
  managePosts: "Manage posts",
  deleteFeed: "Delete feed",
  deleteFeedTitle: "Delete \"{name}\"?",
  deleteFeedText: "Theme blocks that use Feed ID {id} will stop showing posts. Your posts stay in your other feeds.",
  feedDeleted: "Feed deleted",
  feedCreated: "Feed created",
  feedNotFound: "This feed was deleted.",
  backToFeeds: "Feeds",
  showFeedTitle: "Show this feed on your store",
  showFeedSteps: "In the theme editor, add an \"UnboxUGC feed\" block where you want it, then paste {id} into the block's Feed ID setting.",
  feedsLockedTitle: "Create more than one feed",
  feedsLocked: "Show different posts or designs on different pages, each with its own Feed ID.",
};

export default en;
